import { IncomingCallsMap } from "./incomingCallsAction";

const initialState = {
  isLoading: false,
  incomingCallsList: {},
  refreshIncomingCallsList: true,
  searchBy: "",
  searchText: "",
  skip: 0,
  limit: 50,
  selectedIncomingCall: {},
  audioType: "all",
  fromDateFilter: "",
  toDateFilter: "",
  leadType: "all",
  callOutcomeFilter: "all",
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case IncomingCallsMap.GET_ALL_COLD_LEADS_START:
      return {
        ...state,
        isLoading: true,
      };
    case IncomingCallsMap.GET_ALL_COLD_LEADS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        incomingCallsList: action.payload,
        refreshIncomingCallsList: false,
      };
    case IncomingCallsMap.GET_ALL_COLD_LEADS_ERROR:
      return {
        ...state,
        isLoading: false,
        refreshIncomingCallsList: false,
      };
    case IncomingCallsMap.SEARCH_TEXT_CHANGE:
      return {
        ...state,
        searchText: action.payload,
        skip: 0,
        refreshIncomingCallsList: true,
      };
    case IncomingCallsMap.SET_COLD_LEADS_BATCH_NUMBER:
      return {
        ...state,
        skip: action.payload,
        refreshIncomingCallsList: true,
      };
    case IncomingCallsMap.GET_COLD_LEAD_START:
      return {
        ...state,
        isLoading: true,
      };
    case IncomingCallsMap.GET_COLD_LEAD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        selectedIncomingCall: action.payload,
      };
    case IncomingCallsMap.GET_COLD_LEAD_ERROR:
      return {
        ...state,
        isLoading: false,
      };
    case IncomingCallsMap.SET_AUDIO_TYPE:
      return {
        ...state,
        audioType: action.payload,
        skip: 0,
        refreshIncomingCallsList: true,
      };
    case IncomingCallsMap.SET_DATE_FILTER:
      return {
        ...state,
        dateFilter: action.payload,
        skip: 0,
        refreshIncomingCallsList: true,
      };
    case IncomingCallsMap.SET_FROM_DATE_FILTER:
      return {
        ...state,
        fromDateFilter: action.payload,
        skip: 0,
        refreshIncomingCallsList: true,
      };
    case IncomingCallsMap.SET_TO_DATE_FILTER:
      return {
        ...state,
        toDateFilter: action.payload,
        skip: 0,
        refreshIncomingCallsList: true,
      };
    case IncomingCallsMap.SET_LEAD_TYPE:
      return {
        ...state,
        leadType: action.payload,
        skip: 0,
        refreshIncomingCallsList: true,
      };
    case IncomingCallsMap.SET_CALL_OUTCOME_FILTER:
      return {
        ...state,
        callOutcomeFilter: action.payload,
        skip: 0,
        refreshIncomingCallsList: true,
      };
    case IncomingCallsMap.SET_LIMIT:
      return {
        ...state,
        limit: action.payload,
        skip: 0,
        refreshIncomingCallsList: true,
      };
    case IncomingCallsMap.RESET_REFRESH_FLAG:
      return {
        ...state,
        refreshIncomingCallsList: true,
      };
    default:
      return state;
  }
};


